import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class LoyaltyService {
    constructor(private http: HttpClient) {}
    getVouchers() {
        return this.http.get<any>(`${environment.api}/api/customer/vouchers`);
    }
    redeemVoucher(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/addVoucher`,
            data
        );
    }
    pointsHistory() {
        return this.http.get<any>(
            `${environment.api}/api/customer/profile/points_history`
        );
    }
    LoyaltyPointsList(loyaltyObj: any) {
        return this.http.get<any>(
            `${environment.api}/api/customer/profile/loyalty_points_list`,
            {
                params: loyaltyObj,
            }
        );
    }
    getProfile() {
        return this.http.get<any>(`${environment.api}/api/customer/profile`);
    }
    rewardsRedeem(data: any) {
        return this.http.post<any>(
            `${environment.api}/api/customer/rewards/redeem`,
            data
        );
    }
    rewards() {
        return this.http.get<any>(`${environment.api}/api/customer/rewards`);
    }
}
